import { Component, ElementRef, EventEmitter, HostListener, Input, Output, ViewChild } from '@angular/core';
import { faArrowAltCircleLeft, faArrowAltCircleRight } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-pager',
  templateUrl: './pager.component.html',
  styleUrls: ['./pager.component.scss']
})
export class PagerComponent {

  @Input() prevDisabled: boolean = true;
  @Input() nextDisabled: boolean = true;
  @Input() totalNum: number = 0;
  @Input() startNum: number = 0;
  @Input() endNum: number = 0;
  @Input() prevElementFunc: CallableFunction;
  @Input() nextElementFunc: CallableFunction;
  @Output() prevHandler: EventEmitter<void> = new EventEmitter<void>();
  @Output() nextHandler: EventEmitter<void> = new EventEmitter<void>();
  @ViewChild('btnPrev', { static: true }) btnPrev: ElementRef;
  @ViewChild('btnNext', { static: true }) btnNext: ElementRef;

  iconPrev = faArrowAltCircleLeft;
  iconNext = faArrowAltCircleRight;

  onPrevClick() {
    if (this.prevDisabled) {
      return;
    }
    this.prevHandler.emit();
  }

  onNextClick() {
    if (this.nextDisabled) {
      return;
    }
    this.nextHandler.emit();
  }

  @HostListener('keydown', ['$event'])
  onKeydown(event: KeyboardEvent) {
    // TABキーによるフォーカス制御
    if (event.key !== 'Tab') {
      return;
    }
    const target = event.target as HTMLElement;
    switch (target.id) {
      case 'btnPrev':
        if (event.shiftKey) {
          // 前へボタンの前にある部品にフォーカス
          if (this.prevElementFunc != null) {
            event.preventDefault();
            this.prevElementFunc();
          }
          break;
        }
        // 次へボタンが活性化していれば次へボタンにフォーカス
        if (!this.btnNext.nativeElement.classList.contains('disabled')) {
          event.preventDefault();
          this.btnNext.nativeElement.focus();
          break;
        }
        // 次へボタンが非活性化していれば次へボタンの次にフォーカス
        if (this.nextElementFunc != null) {
          event.preventDefault();
          this.nextElementFunc();
        }
        break;
      case 'btnNext':
        if (event.shiftKey) {
          if (!this.btnPrev.nativeElement.classList.contains('disabled')) {
            // 前へボタンが活性化していれば前へボタンにフォーカス
            event.preventDefault();
            this.btnPrev.nativeElement.focus();
            break;
          }
          // 前へボタンの前にある部品にフォーカス
          if (this.prevElementFunc != null) {
            event.preventDefault();
            this.prevElementFunc();
          }
          break;
        }
        // 次へボタンの後にある部品にフォーカス
        if (this.nextElementFunc != null) {
          event.preventDefault();
          this.nextElementFunc();
        }
        break;
    }
  }
}
